import React, { useState } from 'react';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Editor de horário inline no card do Schedule (somente admin edita).
export const ScheduleTimeEditor = ({ job, isAdmin, onSaved }) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(job.time || '');
  const [saving, setSaving] = useState(false);

  const save = async () => {
    const newVal = value || '';
    if (newVal === (job.time || '')) { setEditing(false); return; }
    setSaving(true);
    try {
      await axios.patch(`${API}/schedules/${job.id}`, { time: newVal });
      if (onSaved) onSaved(job.id, newVal);
    } catch (e) {
      console.error('Erro ao salvar horário:', e);
    } finally {
      setSaving(false);
      setEditing(false);
    }
  };

  if (!isAdmin) {
    return job.time ? <div>🕐 {job.time}</div> : null;
  }

  if (editing) {
    return (
      <div className="flex items-center gap-1" onClick={(e) => e.stopPropagation()} onDoubleClick={(e) => e.stopPropagation()}>
        <span>🕐</span>
        <input
          type="time"
          autoFocus
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onBlur={save}
          onKeyDown={(e) => {
            if (e.key === 'Enter') save();
            if (e.key === 'Escape') { setValue(job.time || ''); setEditing(false); }
          }}
          disabled={saving}
          className="border border-indigo-300 rounded px-1 py-0.5 text-[10px] w-[76px]"
          data-testid={`schedule-time-input-${job.id}`}
        />
        {saving && <Loader2 className="h-3 w-3 animate-spin text-indigo-600" />}
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); setValue(job.time || ''); setEditing(true); }}
      className="flex items-center gap-1 hover:text-indigo-600 hover:underline cursor-pointer"
      title="Editar horário"
      data-testid={`schedule-time-edit-${job.id}`}
    >
      🕐 {job.time || '--:--'} <span className="text-[9px] opacity-60">✎</span>
    </button>
  );
};

export default ScheduleTimeEditor;
